module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6wsS3l/tc-custom/9781504083225.jpg?1728851932612",
      "alt": "This image is the cover for the book Remember Me"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Remember Me\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A young mother befriends a new neighbour—but soon finds her an unwelcome presence, in this psychological thriller with a powerful twist.")]), _c('br'), _c('br'), _vm._v(" Sharni and her husband have just moved into 24 The Pines, and they appear to be ideal new neighbours to Clare and Chris. Sharni seems especially fond of Clare. She admires her and is always there to help, especially with childcare for Clare’s two-year-old son."), _c('br'), _c('br'), _vm._v(" But Clare is starting to wonder whether Sharni just wants to be a good neighbour—or wants something more. Like Clare’s husband. Or her child. Or her life. And her anxiety starts to build every time Sharni comes near."), _c('br'), _c('br'), _vm._v(" Is she just being overprotective, or are her worries justified? As Sharni’s influence touches everyone around her, Clare finds herself fighting for both her sanity and her family . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lynda Renham\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0